<template>
    <div class="page aba-imagens">
        <loading :isLoading="isLoading" />
        <div class="columns is-100 is-flex-hright">
            <!-- Botão de Salvar -->
            <div class="listing-header mb-4">
                <div class="header-buttons">
                    <button
                        v-if="
                            (permissao.create || permissao.update) &&
                            !tabelaIntegracao &&
                            !tabelaAssIntegracao
                        "
                        @click="salvar"
                        :disabled="isSaving"
                        class="save-btn"
                        type="button"
                    >
                        {{ $t('salvar') }}
                        <button-loader :isSaving="isSaving" />
                    </button>
                </div>
            </div>
        </div>
        <div class="file-picker-input columns is-100 ml-0">
            <ImgPicker
                v-if="permissao.create && !tabelaIntegracao && !tabelaAssIntegracao"
                ref="filePicker"
                class="upload-picker"
                :extensions="extensionsAllowed"
                :acceptExtension="'.jpg, .png, .jpeg'"
                :qtdImagesAdd="images.length"
                :dataImage="{
                    largura: '2000',
                    altura: '2000',
                    size: '4MB',
                }"
                title=""
                hidePreview
                isCatalogoMini
                @uploadedFiles="getFiles"
                @maxImageAdd="showMessageMaxLimitAdd"
                @filesRemoved="showImagesRemovedMessage"
            />
        </div>
        <div class="photo-list" v-if="images.length > 0">
            <div class="photo-box columns is-100" v-for="(img, i) in imagesPaginated" :key="i">
                <div class="column image-box">
                    <div class="image-as-background">
                        <img
                            :src="
                                img.media && img.media.url
                                    ? img.media.url
                                    : require('@/assets/img/icons/no-image.svg')
                            "
                            :style="{ 'object-fit': 'contain', height: '150px', width: '150px' }"
                            @error="onImageError"
                            :alt="img.media.name"
                        />
                    </div>
                    <p>{{ img.fileName }}</p>
                </div>
                <div class="extra-info-box">
                    <div class="combo-box">
                        <vss-select
                            :id="generateId(1)"
                            title="grade-linha"
                            :value="img.gradelinha"
                            :options="gradeLinhaSelect"
                            :loading="gradeLinhaLoading"
                            @search="loadGradeLinhas"
                            @input="(e) => updateGradeLinhas(i, e)"
                            label="nome"
                            tooltipLabel="info-catalogo-grade-linha"
                            tooltipPosition="is-top"
                            tooltipSize="is-small"
                            searchable
                            clearable
                        />
                    </div>
                    <div class="combo-box">
                        <vss-select
                            :id="generateId(2)"
                            title="item-pacote"
                            :value="img.pacotes"
                            :options="pacoteSelect"
                            :loading="pacoteLoading"
                            @search="loadPacotes"
                            @input="(e) => updatePacotes(i, e)"
                            label="nome"
                            tooltipLabel="info-catalogo-pacote"
                            tooltipPosition="is-top"
                            tooltipSize="is-small"
                            searchable
                            clearable
                            multiple
                        />
                    </div>
                    <div class="combo-box is-100">
                        <vss-select
                            :id="generateId(3)"
                            title="destaque"
                            :value="img.destaqueSelected"
                            :options="destaqueSelect"
                            :invalid="img.destaqueSelected == null"
                            @input="(destaqueSelected) => updateDestaque(i, destaqueSelected)"
                            label="nome"
                            tooltipLabel="info-catalogo-destaque"
                            tooltipPosition="is-top"
                            tooltipSize="is-small"
                        />
                    </div>
                </div>
                <div class="control-box">
                    <b-button
                        v-if="!tabelaIntegracao && !tabelaAssIntegracao && permissao.delete"
                        type="is-danger"
                        icon-right="delete"
                        @click="canRemove(img)"
                        v-tippy
                        :title="$t('delete')"
                    />
                </div>
            </div>
            
        </div>
        <div class="photos-empty-list" v-else>
            <empty-table-message />
        </div>

        <b-modal v-model="openLogs" :can-cancel="!isSaving" scroll="keep">
            <div class="logs-save">
                <div class="button-box is-100">
                    <button class="delete-btn" type="button" @click="cancel()">
                        {{ $t('fechar') }}
                    </button>
                </div>
                <div class="log-box" ref="logbox">
                    <div
                        class="log-line"
                        v-for="(log, i) in logs"
                        :key="i"
                        :ref="i == logs.length - 1 ? 'scrollToMe' : ''"
                    >
                        <p v-if="log.param == null">
                            {{ '[' + log.time + '] ' }} {{ $t(log.message) }}
                        </p>
                        <p v-else>
                            {{ '[' + log.time + '] ' }}
                            {{ $t(log.message, { n: log.param }) }}
                        </p>
                    </div>
                </div>
            </div>
        </b-modal>
        <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
    </div>
</template>

<script>
import ImgPicker from '@/components/shared/form/ImgPicker.vue';
import Message from '@/models/Message';

export default {
    components: {
        ImgPicker,
    },
    data() {
        return {
            tabelaIntegracao: this.$store.state.user.tabelasERPWebServer.includes('MEDIA'),
            tabelaAssIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'ASSMEDIAPRODUTO'
            ),

            extensionsAllowed: ['jpg', 'png', 'jpeg'],
            produtoSelect: [],
            produtoLoading: false,
            destaqueSelect: [
                { nome: this.$t('nao'), value: 0 },
                { nome: this.$t('sim'), value: 1 },
            ],
            gradeLinhaSelect: [],
            gradeLinhaLoading: false,
            pacoteSelect: [],
            pacoteLoading: false,
            newImages: [],
            images: [],
            logs: [],
            imagesPaginated: [],
            imageToRemove: {},
            isSaving: false,
            openLogs: false,
            continueUploading: true,
            isLoading: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissao = this.hasPermissionAccess(
            'vendas',
            'produtos',
            'ven-produto-dados-cadastrais-imagens'
        );

        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'imagens' },
            });

        this.idproduto = this.$route.params.id;

        this.carregarDados();
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-imagens-' + numberId;
        },
        showMessage(type, message) {
            this.msgs.push(new Message(type, message, true));
        },
        carregarDados() {
            this.loadProdutoImagens();
            this.loadGradeLinhas('');
            this.loadPacotes('');
        },
        loadProdutoImagens(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.$axios
            .get(`/sales/product/${this.idproduto}/images.json`, {
                params: {
                    page: currentPage - 1,
                    limit: this.pagination.perPage
                }
            })
            .then(this.mapProdutoImagens)
            .then((image) => {
                this.images = image;
                this.images.push(...this.newImages);
                this.setPagingArray();
            })
            .catch((e) => {
                console.error('Erro ao carregar atendimento agrícola.', e);
            })
            .finally(() => {
                this.isLoading = false;
            });
        },
        onImageError(event) {
            event.target.src = require('@/assets/img/icons/no-image.svg');
        },
        mapProdutoImagens(body) {
            this.pagination.totalRows = body.data.totalElements;

            // Agrupar imagens por idmedia
            const groupedImages = body.data.content.reduce((acc, r) => {
                const mediaId = r.media.idmedia;

                if (acc[mediaId]) {
                    acc[mediaId].assmediaprodutos.push(r.assmediaproduto);

                    if (r.pacote && !acc[mediaId].pacotes.some(p => p.id === r.pacote.idpacote)) {
                        acc[mediaId].pacotes.push({
                            id: r.pacote.idpacote,
                            nome: r.pacote.descricao,
                            descricao: r.pacote.descricao,
                        });
                    }
                } else {
                    acc[mediaId] = {
                        assmediaprodutos: [r.assmediaproduto],
                        fileName: r.fileName,
                        originalName: r.originalName,
                        media: r.media,
                        gradelinha: r.gradelinha
                            ? {
                                id: r.gradelinha.idgradelinha,
                                nome: r.gradelinha.descricao,
                                descricao: r.gradelinha.descricao,
                                idgrade: r.gradelinha.idgrade,
                            }
                            : null,
                        pacotes: r.pacote
                            ? [{
                                id: r.pacote.idpacote,
                                nome: r.pacote.descricao,
                                descricao: r.pacote.descricao,
                            }]
                            : [],
                        destaqueSelected: {
                            nome: this.$t(r.media.destaque == 1 ? 'sim' : 'nao'),
                            value: r.media.destaque,
                        },
                    };
                }

                return acc;
            }, {});

            return Object.values(groupedImages);
        },
        // Grade Linha
        loadGradeLinhas(q) {
            this.gradeLinhaLoading = true;

            this.$axios
                .get(`/sales/gridrow/product/${this.idproduto}/combo.json`, {
                    params: {
                        limit: 30,
                        param: q
                    }
                 })
                .then(this.mapGradeLinhas)
                .then((r) => {
                    this.gradeLinhaSelect = r;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa. Termo: [${q}]`, e);
                })
                .finally((_) => {
                    this.gradeLinhaLoading = false;

                    // if (
                    //     this.gradeLinhaSelect && this.gradeLinhaSelect.length == 1
                    // ) {
                    //     this.images.forEach(
                    //         im => {
                    //             im.gradelinha = this.gradeLinhaSelect[0];
                    //         }
                    //     );
                    // }
                });
        },
        updateGradeLinhas(position, e) {
            let pos = (this.pagination.currentPage - 1) * this.pagination.perPage + position;
            this.images[pos].gradelinha = e;
        },
        mapGradeLinhas(body) {
            return body.data.content.map((r) => {
                return {
                    id: r.idgradelinha,
                    nome: r.descricao,
                    idgradelinhaerp: r.idgradelinhaerp,
                    descricao: r.descricao,
                    idgrade: r.idgrade,
                };
            });
        },
        // Pacote
        loadPacotes(q) {
            this.pacoteLoading = true;

            this.$axios
                .get(`/sales/package/product/${this.idproduto}.json`, {
                    params: {
                        limit: 30,
                        param: q
                    }
                })
                .then(this.mapPacotes)
                .then((r) => {
                    this.pacoteSelect = r;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa. Termo: [${q}]`, e);
                })
                .finally((_) => {
                    this.pacoteLoading = false;

                    // if (
                    //     this.pacoteSelect && this.pacoteSelect.length == 1
                    // ) {
                    //     this.images.forEach(
                    //         im => {
                    //             im.pacote = this.pacoteSelect[0];
                    //         }
                    //     );
                    // }
                });
        },
        updatePacotes(position, e) {
            let pos = (this.pagination.currentPage - 1) * this.pagination.perPage + position;
            // se ainda não tiver um backup dos pacotes antigos, cria um
            if (!this.images[pos].pacotesAntigos) {
                this.$set(this.images[pos], 'pacotesAntigos', [...(this.images[pos].pacotes || [])]);
            }
            this.$set(this.images[pos], 'pacotes', e);
        },
        mapPacotes(body) {
            return body.data.content.map((r) => {
                return {
                    id: r.idpacote,
                    nome: r.descricao,
                    // idpacoteerp: r.idpacoteerp,
                    descricao: r.descricao,
                };
            });
        },

        /**
         * @88773 - percorre a lista e verifica se tem alguma outra imagem com o mesmo produto
         * que tenha o campo destaque com valor 1, levando em conta a paginacao e continuando a
         * leitura do array de dados
         */
        updateDestaque(indexImageSelected, destaqueSelected) {
            const itemsPerPage =
                this.pagination.perPage ||
                this.pagination.perPageOptions[this.pagination.optionStarted];
            const currentPage = this.pagination.currentPage;
            const absoluteIndexImageSelected =
                (currentPage - 1) * itemsPerPage + indexImageSelected;

            if (destaqueSelected.value) {
                for (let indexImage = 0; indexImage < this.images.length; ++indexImage) {
                    const destaqueImageValue = this.images[indexImage].destaqueSelected.value;

                    if (absoluteIndexImageSelected !== indexImage && destaqueImageValue) {
                        this.$root.confirm({
                            message: this.$t('msg-catalogo-destaque-multiplo'),
                            onConfirm: () => {
                                this.images[indexImage].destaqueSelected = this.destaqueSelect[0];
                            },
                            onCancel: () => {
                                this.images[
                                    absoluteIndexImageSelected
                                ].destaqueSelected = this.destaqueSelect[0];
                            },
                        });
                        break;
                    }
                }
            }
            this.images[absoluteIndexImageSelected].destaqueSelected = destaqueSelected;
        },

        // Imagem
        canRemove(img) {
            this.imageToRemove = img;

            this.$root.confirm({
                message: this.$t('msg-catalogo-remocao-imagem'),
                onConfirm: this.remove,
            });
        },
        remove() {
            this.isLoading = true;
            
            const pacoteIds = this.imageToRemove.pacotes && this.imageToRemove.pacotes.length > 0 ? this.imageToRemove.pacotes.map(p => p.id) : null;
            const catalogos = [];
            
            if (pacoteIds) {
                 pacoteIds.forEach((p, i) => {
                    let catalog = {
                        fileName: this.imageToRemove.fileName,
                        originalName: this.imageToRemove.originalName,
                        assmediaproduto: {
                            idassmediaproduto: 
                                Array.isArray(this.imageToRemove.assmediaprodutos) && this.imageToRemove.assmediaprodutos[i] && this.imageToRemove.assmediaprodutos[i].idassmediaproduto
                                    ? this.imageToRemove.assmediaprodutos[i].idassmediaproduto
                                    : null,
                            idproduto: Number(this.idproduto),
                            idpacote: p,
                            idgradelinha: this.imageToRemove.gradelinha ? this.imageToRemove.gradelinha.id : 0,
                            idgrade: this.imageToRemove.gradelinha ? this.imageToRemove.gradelinha.idgrade : 0,
                            idmedia: this.imageToRemove.media ? this.imageToRemove.media.idmedia : null,
                        },
                        media: {
                          ...this.imageToRemove.media,
                        },
                        destaque: this.imageToRemove.destaqueSelected.value,
                 };

                    catalogos.push(catalog);
                })
             } else {
                let catalog = {
                    fileName: this.imageToRemove.fileName,
                    originalName: this.imageToRemove.originalName,
                    assmediaproduto: {
                        idassmediaproduto: this.imageToRemove.assmediaprodutos && this.imageToRemove.assmediaprodutos[0]
                            ? this.imageToRemove.assmediaprodutos[0].idassmediaproduto
                            : null,
                        idproduto: Number(this.idproduto),
                        idpacote: 0,
                        idgradelinha: this.imageToRemove.gradelinha ? this.imageToRemove.gradelinha.id : 0,
                        idgrade: this.imageToRemove.gradelinha ? this.imageToRemove.gradelinha.idgrade : 0,
                        idmedia: this.imageToRemove.media ? this.imageToRemove.media.idmedia : null,
                    },
                    media: {
                        ...this.imageToRemove.media,
                    },
                    destaque: this.imageToRemove.destaqueSelected.value,
                };

                catalogos.push(catalog);
            }

            if (!this.imageToRemove.file) {
                this.$axios.post('/sales/remove-image', catalogos)
                    .then((rem) => {
                        if (rem.data.status == 200) {
                            this.$root.alert({
                                message: this.$t('msg-imagem-removida-sucesso-n', 
                                    { n: this.imageToRemove.fileName }),
                            });
                        } else {
                            this.$root.alert({
                                message: this.$t(rem.message, 
                                    { n: this.imageToRemove.fileName }),
                            });
                        }

                        this.loadProdutoImagens();
                    })
                    .catch((er) => {
                        console.error(`Erro ao remover imagem: `, er);
                    })
                    .finally(() => {
                        this.isLoading = false;
                        this.carregarDados();
                        this.imageToRemove = {};
                    });
            } else {
                const index = this.images.findIndex(img => img.fileName === this.imageToRemove.fileName);
                if (index !== -1) this.images.splice(index, 1);

                const newIndex = this.newImages.findIndex(img => img.fileName === this.imageToRemove.fileName);
                if (newIndex !== -1) this.newImages.splice(newIndex, 1);

                this.images = [...this.images];
                this.newImages = [...this.newImages];

                this.imageToRemove = null;
                this.setPagingArray();
                this.isLoading = false; 
            }
        },
        getFiles(files) {
            files.forEach((f) => {
                let imgFile = {
                    file: f.file,
                    fileName: f.fileName,
                    originalName: f.originalName,
                    media: {
                        url: f.imgurl,
                    },
                    gradelinha: null,
                    pacote: null,
                    destaqueSelected: { nome: this.$t('nao'), value: 0 },
                };

                this.images.push(imgFile);
                this.newImages.push(imgFile);
            });

            this.setPagingArray();
        },
        async salvar() {
            if (this.images && this.images.length > 0 && this.validateCanSave()) {
                this.isSaving = true;
                this.log = [];
                this.continueUploading = true;
                this.openLogs = true;
                this.logs.push({
                    message: 'msg-catalogo-log-inicializando-processamento',
                    param: null,
                    time: this.$moment().format('L LTS'),
                });

                for (const element of this.images) {
                    if (this.continueUploading) {
                        try {
                            let img = element;

                            const pacoteIds = img.pacotes && img.pacotes.length > 0 ? img.pacotes.map(p => p.id) : null
                            const catalogos = []

                            if (pacoteIds !== null) {
                                pacoteIds.forEach((p, i) => {
                                    let catalog = {
                                        fileName: img.fileName,
                                        originalName: img.originalName,
                                        assmediaproduto: {
                                            idassmediaproduto: 
                                            Array.isArray(img.assmediaprodutos) && img.assmediaprodutos[i] && img.assmediaprodutos[i].idassmediaproduto
                                                ? img.assmediaprodutos[i].idassmediaproduto
                                                : null,
                                            idproduto: Number(this.idproduto),
                                            idpacote: p,
                                            idgradelinha: img.gradelinha ? img.gradelinha.id : 0,
                                            idgrade: img.gradelinha ? img.gradelinha.idgrade : 0,
                                            idmedia: img.media ? img.media.idmedia : null,
                                        },
                                        media: {
                                            idmedia: img.media ? img.media.idmedia : null,
                                        },
                                        destaque: img.destaqueSelected.value,
                                };
                                catalogos.push(catalog)
                            })
                            } else {
                                let catalog = {
                                    fileName: img.fileName,
                                    originalName: img.originalName,
                                    assmediaproduto: {
                                    idassmediaproduto: img.assmediaproduto
                                        ? img.assmediaproduto.idassmediaproduto
                                        : null,
                                    idproduto: Number(this.idproduto),
                                    idpacote: 0,
                                    idgradelinha: img.gradelinha ? img.gradelinha.id : 0,
                                    idgrade: img.gradelinha ? img.gradelinha.idgrade : 0,
                                    idmedia: img.media ? img.media.idmedia : null,
                                    },
                                    media: {
                                    idmedia: img.media ? img.media.idmedia : null,
                                    },
                                    destaque: img.destaqueSelected.value,
                                };
                                catalogos.push(catalog)
                            }
                            

                            if (img.file) {
                                this.logs.push({
                                    message: 'msg-catalogo-log-enviando-n',
                                    param: img.originalName,
                                    time: this.$moment().format('L LTS'),
                                });

                                // ENVIA IMAGEM PRO SERVER PARA SER UPADA NA AWS
                                const data = new FormData();
                                data.append('file', img.file);
                                data.append('catalogo', new Blob([JSON.stringify(catalogos)], { type: "application/json" }));

                                await this.$axios.post('/sales/catalog', data, {
                                    headers: {
                                        'Content-Type': undefined,
                                    },
                                })
                                .then((r) => {
                                        if (r.data.content) {
                                            this.logs.push({
                                                message: 'msg-catalogo-log-enviado-n',
                                                param: img.originalName,
                                                time: this.$moment().format('L LTS'),
                                            });
                                        } else {
                                            this.logs.push({
                                                message: r.message,
                                                time: this.$moment().format('L LTS'),
                                            });
                                        }
                                    })
                                    .catch((e) => {
                                        if (e.data.message) {
                                            if (e.message.endsWith('-n')) {
                                                this.logs.push({
                                                    message: e.data.message,
                                                    param: img.originalName,
                                                    time: this.$moment().format('L LTS'),
                                                });
                                            } else {
                                                this.logs.push({
                                                    message: e.data.message,
                                                    time: this.$moment().format('L LTS'),
                                                });
                                            }
                                        }
                                    });
                            } else {
                                this.logs.push({
                                    message: 'msg-iniciando-atualizacao-imagem-n',
                                    param: img.originalName,
                                    time: this.$moment().format('L LTS'),
                                });

                                if (img.pacotesAntigos && Array.isArray(img.pacotesAntigos)) {
                                    const antigos = new Set(img.pacotesAntigos.map(p => Number(p.id || p)));
                                    const atuais = new Set((img.pacotes || []).map(p => Number(p.id || p)));

                                    const removidos = [...antigos].filter(id => !atuais.has(id));

                                    for (const idRemovido of removidos) {
                                        const vinculo = img.assmediaprodutos && img.assmediaprodutos.find(a => a.idpacote === idRemovido);
                                        if (vinculo && vinculo.idassmediaproduto) {
                                            try {
                                                await this.$axios.post(`/sales/remove-media-produto/${vinculo.idassmediaproduto}`);
                                                this.logs.push({
                                                    message: 'msg-pacote-removido-n',
                                                    param: idRemovido,
                                                    time: this.$moment().format('L LTS'),
                                                });
                                            } catch (e) {
                                                this.logs.push({
                                                message: 'msg-erro-remover-pacote-n',
                                                param: idRemovido,
                                                time: this.$moment().format('L LTS'),
                                            });
                                        }
                                    }
                                }
                            }
                            await this.$axios
                                .post('/sales/update-images-details', catalogos)
                                .then(() => {
                                    this.logs.push({
                                        message: 'msg-imagem-atualizada-n',
                                        param: img.originalName,
                                        time: this.$moment().format('L LTS'),
                                    });
                                })
                                .catch((e) => {
                                    this.logs.push({
                                        message: e.data.message,
                                        time: this.$moment().format('L LTS'),
                                    });
                               });
                                img.pacotesAntigos = [...(img.pacotes || [])];
                            }
                        } catch (e) {
                            console.error('Erro: ', e);
                        }
                    }
                }

                this.logs.push({
                    message: this.continueUploading
                        ? 'msg-catalogo-log-finalizou-processamento'
                        : 'msg-catalogo-log-cacelou-processamento',
                    param: null,
                    time: this.$moment().format('L LTS'),
                });

                this.isSaving = false;

                this.carregarDados();
                this.newImages = [];
            }
        },
        cancel() {
            this.continueUploading = false;
            this.openLogs = false;
        },
        showMessageMaxLimitAdd() {
            let message = this.$t('msg-catalogo-imagens-maximo-adicionado');

            this.$root.alert({
                message: message,
            });
        },
        showImagesRemovedMessage(numOfImages) {
            let qtdDimensao = numOfImages.qtdDimensao;
            let qtdExtensao = numOfImages.qtdExtensao;
            let qtdSize = numOfImages.qtdSize;
            let qtdErasedByLimit = numOfImages.qtdErasedByLimit;

            if (qtdDimensao > 0 || qtdExtensao > 0 || qtdSize > 0 || qtdErasedByLimit > 0) {
                let message = '';
                if (qtdDimensao > 0) {
                    message +=
                        this.$t('msg-catalogo-imagens-maiores-dimensao-maxima-n', { n: qtdDimensao }) + '<br>';
                }

                if (qtdExtensao > 0) {
                    message +=
                        this.$t('msg-catalogo-imagens-extensao-nao-permitida-n', { n: qtdExtensao }) + '<br>';
                }

                if (qtdSize > 0) {
                    message +=
                        this.$t('msg-catalogo-imagens-tamanho-nao-permitido-n', { n: qtdSize }) + '<br>';
                }

                if (qtdErasedByLimit > 0) {
                    message += this.$t('msg-catalogo-imagens-removido-limit-n', { n: qtdErasedByLimit });
                }

                this.$root.alert({
                    message: message,
                });
            }
        },
        validateCanSave() {
            let count = 0;
            let totalImages = this.images.length;
            this.images.forEach((x) => {
                if (x.destaqueSelected != null) {
                    count++;
                }
            });

            return count == totalImages;
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;

            this.setPagingArray();
        },
        setPagingArray() {
            this.imagesPaginated = this.images.slice(
                (this.pagination.currentPage - 1) * this.pagination.perPage,
                this.pagination.currentPage * this.pagination.perPage
            );
            this.pagination.totalRows = this.images.length;
        },
    },
};
</script>

<style lang="scss" scoped>
@mixin smallbtn() {
    height: 36px;
    font-size: 12px;
    color: $sovis-white;
    @include gradient-button();
}

#main .page.aba-imagens,
.photo-list {
    padding: 20px 20px;
}

.aba-imagens .photo-list {
    display: flex;
    width: 100%;
    height: auto;
    justify-content: center;
    padding: 20px 10px;
    border: 1px solid $table-border;
    flex-wrap: wrap;

    .photo-box {
        border-bottom: 3px solid $light-gray-color;
        margin-bottom: 20px;

        .image-box {
            flex-grow: 0;
            padding: 5px;

            .image-as-background {
                width: 150px;
                height: 150px;
            }
        }

        .extra-info-box {
            display: flex;
            flex-wrap: wrap;
            flex-grow: 1;
            justify-content: space-between;
            padding: 5px 10px;

            .combo-box {
                width: 49%;
                height: 70px;
                margin-bottom: -40px;
            }

            .combo-box:nth-child(3),
            .combo-box:nth-child(4) {
                margin-bottom: auto;
            }
        }

        .control-box {
            width: 100px;
            display: flex;
            justify-content: flex-end;
            align-items: center;

            > span {
                margin-top: auto;
                margin-left: auto;
                margin-right: 0 !important;
            }
        }
    }
}

.aba-imagens .modal-content {
    .logs-save {
        display: flex;
        width: 100%;
        justify-content: flex-start;
        padding: 10px;
        border-radius: 10px;
        background-color: #fff;
        flex-wrap: wrap;
        .button-box {
            flex-grow: 0;
            display: flex;
            margin-bottom: 10px;
            justify-content: flex-end;

            .delete-btn {
                padding: 15px 25px;
            }
        }

        .log-box {
            width: 100%;
            overflow: auto;
            border: 1px solid $table-border;
            position: relative;
            height: 600px;

            .log-line {
                font-size: 14px;
                color: $sovis-black;
            }
        }
    }
}

.aba-imagens .photo-list:last-child .combo-box {
    border-bottom: none;
}
</style>
